import { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';

import { chatChartBaseOptions } from './chatChartOptions';
import { getDatasetColors, VisualizationBarChart } from './visualizationTypes';

type ChatVisualizationBarChartProps = {
  visualization: VisualizationBarChart;
};

export default function ChatVisualizationBarChart({
  visualization,
}: ChatVisualizationBarChartProps) {
  const colors = getDatasetColors(visualization.datasets.length);
    const totalBars =
        visualization.labels.length * visualization.datasets.length;

    const showDataLabels = totalBars <= 10;

    const chartData = useMemo(
    () => ({
      labels: visualization.labels,
      datasets: visualization.datasets.map((dataset, index) => ({
        label: dataset.label,
        data: dataset.data,
        backgroundColor: colors[index],
        borderRadius: 4,
        maxBarThickness:
            totalBars > 20 ? 16 :
            totalBars > 10 ? 24 :
             36,
        datalabels: {
          display: showDataLabels,
          anchor: 'end' as const,
          align: 'top' as const,
          offset: 3,
          clamp: true,
          clip: false,
          color: '#4B5563',
          font: {
              size: totalBars <= 6 ? 12 : 10,
              weight: 'bold' as const,
          },
        },
      })),
    }),
    [colors, showDataLabels, totalBars, visualization.datasets, visualization.labels],
  );

  return (
    <div className="h-64 w-full px-2 py-2">
      <Bar data={chartData} options={chatChartBaseOptions} />
    </div>
  );
}
